<template>
  <div
    @click.prevent="navigate($event)"
    class="w-full lg:w-1/4 sm:w-1/2 sm:p-2"
  >
    <div class="border rounded-lg">
      <div class="flex items-center justify-center flex-col bg-card mb-4">
        <div class="w-full mb-8 text-right p-2">
          <div class="text-gray-200">
            <span id="edit" class="cursor-pointer p-2"
              ><i id="edit" class="fas fa-edit text-lg"></i
            ></span>
            <span id="delete" class="ml-2 cursor-pointer p-2"
              ><i id="delete" class="fas fa-trash-alt text-lg"></i
            ></span>
          </div>
        </div>
        <div class="mb-8">
          <img
            src="https://res.cloudinary.com/lms-edc/image/upload/v1592678196/Assets/fpnq5oct5z1brb9wubxy.png"
            alt=""
          />
        </div>
      </div>
      <div class="px-2">
        <h5 class="text-xl font-semibold">{{ survey.title }}</h5>

        <div class="flex justify-between">
          <p
            @click="navigate(survey.id)"
            class="text-sm font-semibold cursor-pointer"
          >
            View Submissions
          </p>
          <a class="text-sm font-semibold" href="">Share Survey -></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "survey-card",
  props: ["survey"],
  methods: {
    ...mapActions(["tenantDeleteSurvey"]),
    async deleteSurvey() {
      let res = await this.tenantDeleteSurvey({
        id: this.survey.id,
      });
      if (res.status === 200 || res.status === 201) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Survey deleted successfully",
        });
        window.location.reload();
      } else {
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
                  ? res.data.errors[0].title
                  : "An error occured",
        });
      }
    },
    handleClick() {
      this.$confirm({
        message: `Are you sure you want to delete this Survey ?`,
        button: {
          no: "No",
          yes: "Yes",
        },

        callback: (confirm) => {
          if (confirm) {
            this.deleteSurvey();
          }
        },
      });
    },
  navigate(e) {
    e.stopImmediatePropagation();
    if (e.target.id == "edit") {
      this.$router.push({
        name: "tenant-survey-edit",
        params: {survey_id: this.survey.id},
      });
    } else if (e.target.id === "delete") {
      this.handleClick()
    } else {
      this.$router.push({
        name: "tenant-survey-summary",
        params: {survey_id: this.survey.id},
      });
    }
  },
  },
};
</script>
<style lang="scss">
.bg-card {
  background-color: color(lms-tenant);
}
</style>
